var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.despesa.justificativaRateio)?_c('div',{staticClass:"float-left mr-1"},[_c('span',{staticClass:"text-warning"},[_c('i',{staticClass:"fa fa-file-text fa-lg icon-button",attrs:{"title":"Justificativa"},on:{"click":function($event){$event.stopPropagation();return _vm.mostrarJustificativa()}}})])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }